import { animated, useSpring } from "react-spring";
import { springConfigs } from "../../../constants/springConfigs";
import { useWindowSize } from "../../../hooks/useWindowSize";

export const HackingTheCell = ({ gridArea }) => {
  const { marginTop } = useSpring({
    from: { marginTop: "20px" },
    to: { marginTop: "0px" },
    config: springConfigs.textAppear,
  });
  const {
    horizontal,
    h,
    appContentContainerHeight,
    appContentContainerHeightValue,
  } = useWindowSize();

  return (
    <div
      {...{
        style: {
          gridArea,
          letterSpacing: "0.6em",
          fontSize: h(1.62),
          marginBottom: horizontal ? 0 : "1.5rem",
          overflowY: "hidden",
          fontWeight: "700",
        },
      }}
    >
      <animated.div {...{ style: { marginTop: marginTop } }}>
        HACKING THE CELL
      </animated.div>
    </div>
  );
};
